<template>
    <div class="content-container">
        <!-- 搜索條件 -->
        <a-form-model class="search-form" layout="inline" :model="searchForm">
            <!-- 所屬團隊 -->
            <a-form-model-item
                    has-feedback
                    :label="$t('form.common.field.team.label2')"
            >
                <a-input
                        v-model="searchForm.team_name"
                        :placeholder="$t('form.common.field.team.placeholder')"
                />
            </a-form-model-item>
            <!-- 搜索按鈕 -->
            <a-form-model-item>
                <a-button type="primary" html-type="submit" @click="onSearch">{{
                    $t(`actionTitles.submit`)
                    }}</a-button>
                <a-button :style="{ marginLeft: '8px' }" @click="handleReset">{{
                    $t(`actionTitles.clear`)
                    }}</a-button>
            </a-form-model-item>
        </a-form-model>

        <!-- 表格 -->
        <div class="table-wrapper">
            <a-table
                    :data-source="teamList"
                    :loading="loading"
                    rowKey="id"
                    :pagination="pagination"
                    @change="handleTableChange"
            >
                <!-- 團隊名稱 -->
                <a-table-column
                        key="name"
                        :title="$t('table.team.thead.name')"
                        data-index="name"
                        align="center"
                />
                <!-- 創建者 -->
                <a-table-column
                        key="team_header_name"
                        :title="$t('table.team.thead.leader')"
                        data-index="team_header_name"
                        align="center"
                >
                    <template slot-scope="text, record">
                        <span>{{ record.team_header_name}}</span>
                        <h5 style="margin-bottom: 0">{{ record.team_header_phone}}</h5>
                    </template>
                </a-table-column>
                <!-- 創建時間 -->
                <a-table-column
                        key="create_time"
                        :title="$t('table.common.thead.createTime')"
                        data-index="create_time"
                        :sorter="true"
                        align="center"
                />
                <!-- 到期時間 -->
                <a-table-column
                        key="team_expire_time"
                        :title="$t('table.common.thead.expireTime')"
                        data-index="team_expire_time"
                        :sorter="true"
                        align="center"
                />
                <!-- 作品數量 -->
                <a-table-column
                        key="work_num"
                        :title="$t('table.team.thead.workNum')"
                        data-index="work_num"
                        align="center"
                />
                <!-- 瀏覽量 -->
                <a-table-column
                        key="total_browse"
                        :title="$t('table.team.thead.viewNum')"
                        data-index="total_browse"
                        align="center"
                />

                <!-- 容量 -->
                <a-table-column
                        key="capacity"
                        :title="$t('table.team.thead.volume')"
                        data-index="capacity"
                        align="center"
                >
                    <template slot-scope="text, record">
                        <a-progress
                                :percent="percent(record.use_capacity,record.capacity)"
                                :show-info="false"
                                status="active"
                        />
                        <span>{{record.use_capacity}}G/{{ record.capacity}}G</span>
                    </template>
                </a-table-column>
                <!-- 團隊人數 -->
                <a-table-column
                        key="limit_num"
                        :title="$t('table.team.thead.members')"
                        data-index="limit_num"
                        align="center"
                >
                    <template slot-scope="text, record">
                        <a-progress
                                :percent="percent(record.use_num,record.limit_num)"
                                :show-info="false"
                                status="active"
                        />
                        <span>{{record.use_num}}人/{{ record.limit_num}}人</span>
                    </template>
                </a-table-column>
                <!-- 操作 -->
                <a-table-column
                        key="operate"
                        :title="$t('table.common.thead.operate')"
                        align="center"
                >
                    <template slot-scope="text, record">
                        <span class="operate-btn" @click="viewMember(record)">{{$t('table.team.operate.viewMember')}}</span>
                        <span class="operate-btn" @click="dilatation(record)">{{$t('table.team.operate.dilatation')}}</span>
                    </template>
                </a-table-column>
            </a-table>
        </div>

        <!-- 擴容 -->
        <a-modal
            :visible="dilatationVisible"
            :destroyOnClose="true"
            :width="400"
            :title="$t('table.team.operate.dilatation')"
            @cancel="closeDilatationModal"
            @ok="dilatationEvent"
        >
            <div class="dilatation-list">
                <div class="labels">{{$t('table.team.operate.volume.label')}}</div>
                <a-input-number :min="0" :placeholder="$t('table.team.operate.volume.placeholder')" v-model="currTeam.capacity"/>
                <span class="unit">G</span>
            </div>
            <div class="dilatation-list">
                <div class="labels">{{$t('table.team.operate.member.label')}}</div>
                <a-input-number :min="0" :placeholder="$t('table.team.operate.member.placeholder')" v-model="currTeam.limit_num"/>
                <span class="unit">人</span>
            </div>
        </a-modal>
    </div>
</template>

<script>
    import {getTeamList,updTeamUserNum} from "@/api/team"
    export default {
        name: "List",
        data(){
            return{
                searchForm: {},
                pagination: {
                    showQuickJumper: true,
                    current: 1,
                    pageSize: 10,
                    total: 0,
                },
                loading: false,
                teamList: [],

                dilatationVisible: false,
                currTeam:{}
            }
        },
        mounted() {
            this.loadData()
        },
        methods:{
            //數據加載
            loadData(){
                this.loading = true
                let searchParam = {
                    ...this.searchForm,
                    current_page: this.pagination.current,
                    per_page: this.pagination.pageSize
                }
                getTeamList(searchParam).then(res=>{
                    if(res.code == 1){
                        this.loading = false
                        this.teamList = res.data.data
                        this.pagination.total = res.data.total
                    }
                }).catch(err=>{
                    console.log(err)
                    this.loading = false
                })
            },
            //搜索
            onSearch(){
                this.pagination.current = 1;
                this.loadData();
            },
            //清空搜索條件
            handleReset(){
                this.searchForm = {}
                this.onSearch()
            },
            //翻頁等
            handleTableChange(pagination, filters, sorter){
                this.pagination = pagination;
                if (Object.keys(sorter).length > 0) {
                    let field = sorter.field;
                    let orderStr = sorter.order == "ascend" ? "asc" : "desc";

                    let order = {};
                    order[field] = orderStr;
                    this.searchForm.order = order;
                }
                this.loadData();
            },
            //跳轉查看成員
            viewMember(item){
                this.$router.push({
                    name: "adminUserList",
                    params:{team_name: item.name}
                })
            },
            //打開擴容
            dilatation(item){
                this.currTeam = JSON.parse(JSON.stringify(item))
                this.dilatationVisible = true
            },
            //關閉擴容
            closeDilatationModal(){
                this.dilatationVisible = false
                this.currTeam = {}
            },
            //擴容
            dilatationEvent(){
                if(!this.currTeam.limit_num){
                    this.$message.error(this.$t('table.team.operate.member.message'))
                    return;
                }
                if(!this.currTeam.capacity){
                    this.$message.error(this.$t('table.team.operate.volume.message'))
                    return;
                }
                let data = {
                    team_id: this.currTeam.id,
                    limit_num: this.currTeam.limit_num,
                    capacity: this.currTeam.capacity
                }
                updTeamUserNum(data).then(res=>{
                    if(res.code == 1){
                        this.$message.success(res.message,1)
                        this.dilatationVisible = false
                        this.loadData()
                    }
                }).catch(err=>{
                    console.log(err)
                })
            },
            //計算百分比
            percent(use_num,total_num){
                return (parseFloat(use_num) / parseFloat(total_num)) * 100
            }
        }
    }
</script>

<style lang="less" scoped>
    .operate-btn{
        color: #1890ff;
        margin: 0 8px;
        cursor: pointer;
        display: inline-block;
    }
    .dilatation-list{
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        .labels{
            width: 90px;
            flex-shrink: 0;
            text-align: right;
            margin-right: 15px;
        }
        .ant-input-number{
            width: 190px;
        }
        .unit{
            color: #aaa;
            font-size: 12px;
            flex-shrink: 0;
            margin-left: 8px;
        }
    }
</style>